import _defineProperty from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import Divider from '@mui/material/Divider';
import RcSwitch from 'rc-switch';
import { Button } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Autocomplete from '@mui/material/Autocomplete';
import ListItem from '@mui/material/ListItem';
import Row from 'react-bootstrap/Row';
import TextField from '@mui/material/TextField';
import styles from '../styles/file-uploader.less';
import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = logger.createLogger('CategoryRowsComponent');
function CategoryRow(_ref) {
  var specifyCategories = _ref.specifyCategories,
    tableObj = _ref.tableObj,
    hyperedges = _ref.hyperedges,
    setHyperedgeBindings = _ref.setHyperedgeBindings,
    catID = _ref.catID,
    catName = _ref.catName,
    cols = _ref.cols,
    error = _ref.error;
  var usedCols = {};
  var cats = ((hyperedges || {}).opts || {}).CATEGORIES || {};
  var cats2 = hyperedges.categories || {};
  log.info({
    cats2: cats2
  }, 'cats2');
  for (var _i = 0, _Object$entries = Object.entries(cats2); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      catID2 = _Object$entries$_i[0],
      otherValues = _Object$entries$_i[1];
    log.info({
      catID2: catID2,
      otherValues: otherValues
    }, 'cat2 step');
    if (catID2 === catID) {
      continue;
    }
    var _iterator = _createForOfIteratorHelper(otherValues[1]),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var otherCol = _step.value;
        usedCols[otherCol] = true;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  //const unusedCols = Object.keys(tableObj.dtypes).filter(v => !usedCols[v]);

  return /*#__PURE__*/_jsxs(Row, {
    className: styles['category-row'],
    children: [/*#__PURE__*/_jsx(Col, {
      className: styles['category-row-name-col'],
      children: /*#__PURE__*/_jsx(TextField, {
        disabled: !specifyCategories,
        error: error,
        helpertext: error ? 'Duplicate category name' : '',
        variant: "outlined",
        label: "Category name",
        placeholder: "",
        value: catName,
        onChange: function onChange(evt, value) {
          var newName = evt.target.value;
          var duplicateError = !!cats[newName];

          //order preserving
          var categoriesCopy = {};
          for (var _i2 = 0, _Object$entries2 = Object.entries(hyperedges.categories || {}); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              _catID = _Object$entries2$_i[0],
              _value = _Object$entries2$_i[1];
            categoriesCopy[_catID] = catID === _catID ? [newName, cols, duplicateError] : _value;
          }

          //order preserving
          var catsCopy = {};
          for (var _i3 = 0, _Object$entries3 = Object.entries(categoriesCopy); _i3 < _Object$entries3.length; _i3++) {
            var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
              _catID2 = _Object$entries3$_i[0],
              _value2 = _Object$entries3$_i[1];
            if (!_value2[2]) {
              catsCopy[_value2[0]] = _value2[1];
            }
          }
          setHyperedgeBindings(function (bindings) {
            return _objectSpread(_objectSpread({}, bindings), {}, {
              opts: _objectSpread(_objectSpread({}, bindings.opts || {}), {}, {
                CATEGORIES: catsCopy
              }),
              categories: categoriesCopy
            });
          });
        }
      })
    }), /*#__PURE__*/_jsx(Col, {
      children: /*#__PURE__*/_jsx(Autocomplete, {
        multiple: true,
        disabled: !specifyCategories,
        options: Object.keys(tableObj.dtypes),
        value: cols,
        includeInputInList: true,
        disableClearable: true,
        openOnFocus: true,
        autoHighlight: true,
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
            variant: "outlined"
          }, params), {}, {
            label: "Columns",
            margin: "normal"
          }));
        },
        getOptionDisabled: function getOptionDisabled(option) {
          return usedCols[option];
        },
        onChange: function onChange(event, newValues) {
          setHyperedgeBindings(function (hyperedges) {
            //order preserving
            var categoriesCopy = {};
            for (var _i4 = 0, _Object$entries4 = Object.entries(hyperedges.categories || {}); _i4 < _Object$entries4.length; _i4++) {
              var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
                _catID3 = _Object$entries4$_i[0],
                value = _Object$entries4$_i[1];
              categoriesCopy[_catID3] = catID === _catID3 ? [catName, newValues, value[2]] : value;
            }

            //order preserving
            var catsCopy = {};
            for (var _i5 = 0, _Object$entries5 = Object.entries(categoriesCopy); _i5 < _Object$entries5.length; _i5++) {
              var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
                _catID4 = _Object$entries5$_i[0],
                _value3 = _Object$entries5$_i[1];
              if (!_value3[2]) {
                catsCopy[_value3[0]] = _value3[1];
              }
            }
            return _objectSpread(_objectSpread({}, hyperedges), {}, {
              opts: _objectSpread(_objectSpread({}, hyperedges.opts || {}), {}, {
                CATEGORIES: catsCopy
              }),
              categories: categoriesCopy
            });
          });
        }
      })
    }), /*#__PURE__*/_jsx(Col, {
      className: styles['category-row-button-col'],
      children: /*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        size: "small",
        className: styles['shaper-delete'],
        onClick: function onClick() {
          setHyperedgeBindings(function (hyperedges) {
            //order preserving
            var categoriesCopy = _objectSpread({}, hyperedges.categories || {});
            delete categoriesCopy[catID];

            //order preserving
            var catsCopy = {};
            for (var _i6 = 0, _Object$entries6 = Object.entries(categoriesCopy); _i6 < _Object$entries6.length; _i6++) {
              var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i6], 2),
                _catID5 = _Object$entries6$_i[0],
                value = _Object$entries6$_i[1];
              if (!value[2]) {
                catsCopy[value[0]] = value[1];
              }
            }
            return _objectSpread(_objectSpread({}, hyperedges), {}, {
              opts: _objectSpread(_objectSpread({}, hyperedges.opts || {}), {}, {
                CATEGORIES: catsCopy
              }),
              categories: categoriesCopy
            });
          });
        },
        children: /*#__PURE__*/_jsx("i", {
          style: {
            fontSize: '18px'
          },
          className: "fa fa-trash"
        })
      })
    })]
  }, "key-cr2-".concat(catID));
}

//Note that iteration is by hyperedges.categories
function categoryRows(_ref2) {
  var hyperedges = _ref2.hyperedges,
    tableObj = _ref2.tableObj,
    setHyperedgeBindings = _ref2.setHyperedgeBindings,
    specifyCategories = _ref2.specifyCategories;
  var categories = (hyperedges || {}).categories || {};
  var rows = [];
  for (var _i7 = 0, _Object$entries7 = Object.entries(categories); _i7 < _Object$entries7.length; _i7++) {
    var _Object$entries7$_i = _slicedToArray(_Object$entries7[_i7], 2),
      catID = _Object$entries7$_i[0],
      colKVPair = _Object$entries7$_i[1];
    rows.push(/*#__PURE__*/_jsx(CategoryRow, {
      specifyCategories: specifyCategories,
      tableObj: tableObj,
      hyperedges: hyperedges,
      setHyperedgeBindings: setHyperedgeBindings,
      catID: catID,
      catName: colKVPair[0],
      cols: colKVPair[1],
      error: colKVPair[2]
    }, "key-cr-".concat(catID)));
  }
  return rows;
}
export function CategoryRowsComponent(_ref3) {
  var hyperedges = _ref3.hyperedges,
    tableObj = _ref3.tableObj,
    setHyperedgeBindings = _ref3.setHyperedgeBindings,
    specifyCategories = _ref3.specifyCategories,
    mergeAllCategories = _ref3.mergeAllCategories;
  var rows = categoryRows({
    hyperedges: hyperedges,
    tableObj: tableObj,
    setHyperedgeBindings: setHyperedgeBindings,
    specifyCategories: specifyCategories
  });
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(ListItem, {
      children: [/*#__PURE__*/_jsx(RcSwitch, {
        onChange: function onChange(value) {
          setHyperedgeBindings(function (bindings) {
            return _objectSpread(_objectSpread({}, bindings), {}, {
              mergeAllCategories: !mergeAllCategories,
              specifyCategories: false
            });
          });
        },
        checked: mergeAllCategories,
        checkedChildren: 'on',
        unCheckedChildren: 'on'
      }), "Merge values duplicated across all columns"]
    }), /*#__PURE__*/_jsxs(ListItem, {
      children: [/*#__PURE__*/_jsx(RcSwitch, {
        onChange: function onChange(value) {
          setHyperedgeBindings(function (bindings) {
            return _objectSpread(_objectSpread({}, bindings), {}, {
              mergeAllCategories: false,
              specifyCategories: !specifyCategories
            });
          });
        },
        checked: specifyCategories,
        checkedChildren: 'on',
        unCheckedChildren: 'on'
      }), "Specify column categories for merging duplicate values"]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Container, {
      children: rows
    }), /*#__PURE__*/_jsxs(Button, {
      className: "".concat(styles['edge-footer-button'], " ").concat(rows.length ? '' : styles['edge-footer-button-mt']),
      disabled: !specifyCategories,
      onClick: function onClick() {
        var cats = ((hyperedges || {}).opts || {}).CATEGORIES || {};
        var name = 'cat_untitled';
        while (name in cats) {
          name += '1';
        }
        ;
        var catID = "c".concat(Object.keys((hyperedges || {}).categories || {}).length + 1);
        setHyperedgeBindings(function (bindings) {
          return _objectSpread(_objectSpread({}, bindings), {}, {
            opts: _objectSpread(_objectSpread({}, bindings.opts || {}), {}, {
              CATEGORIES: _objectSpread(_objectSpread({}, cats), {}, _defineProperty({}, name, []))
            }),
            categories: _objectSpread(_objectSpread({}, (hyperedges || {}).categories || {}), {}, _defineProperty({}, catID, [name, [], false]))
          });
        });
      },
      children: [/*#__PURE__*/_jsx("i", {
        className: "fa fa-plus"
      }), " Add category"]
    })]
  });
}